import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 20px;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const HeaderStyles = styled.div`
    display: flex;
`;

export const BackArrowIcon = styled.div`
    display: flex;
    cursor: pointer;
`;

export const Title = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
    margin-top: 20px;
`;

export const Text = styled.div`
    margin-top: 20px;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #5b5675;
    margin-bottom: 20px;
`;

export const RowWrapper = styled.div`
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
`;
